<template>
    <div class="d-flex flex-column">
        <el-upload class="upload-demo" ref="upload"
                   :action="action"
                   :accept="accept"
                   :file-list="fileList"
                   :on-preview="doDownload"
                   auto-upload
                   multiple
                   drag
                   :on-change="handleChange"
                   :on-remove="handleRemove"
                   :on-error="handleError"
                   :before-upload="beforeUpload">
            <el-button size="small" type="primary" icon="el-icon-plus" plain>
                文件上传 {{ fileList.length }} 个
            </el-button>
        </el-upload>
    </div>

</template>

<script>

import attachmentMixin from "@/mixin/em/common/stuffs/attachment/attachmentMixin";

export default {
    name: "MultiAttachment",
    mixins: [attachmentMixin],
    props: {
        attachmentIds: {
            type: String,
            default: ""
        },
        queryApi: {
            type: String,
            default: process.env.VUE_APP_EM_ADMIN_URL +
                "/emAttachment/getAttachmentList"
        }
    },
    data() {
        return {
            fileList: [], // 上传文件列表
            action: process.env.VUE_APP_EM_ADMIN_URL + "/emAttachment/upload",
            accept: 'application/pdf,.doc,.docx,.xls,.xlsx,.jpg, .jpeg, .png, .rar, .zip, .7z',
            loading: false
        }
    },
    watch: {
        fileList: {
            handler() {
                this.$emit('idsChanged', this.getAttachmentIds());
                // 进度 100% 只代表字节已发出，服务端返回 id 前文件不在 idsChanged 里，需让父组件知道仍在上传
                this.$emit('uploadingChanged', this.fileList.some(file => file.status === 'ready' || file.status === 'uploading'));
            }
        },
        deep: true
    },
    mounted() {
        this.getRemoteData();
    },
    methods: {
        getRemoteData() {
            if (this.attachmentIds) {
                this.$emit('loading', true);
                this.loading = true;
                let url = this.queryApi + "?attachmentIds=" + this.attachmentIds;
                this.$store.dispatch('api/get', {url: url}).then(response => {
                    if (response.length > 0) {
                        for (let item of response) {
                            this.fileList.push({
                                name: item.fileName,
                                url: process.env.VUE_APP_EM_ADMIN_URL + "/emAttachment/download?attachmentId=" + item.attachmentId,
                                response: {
                                    id: item.attachmentId
                                }
                            })
                        }
                    }
                }).finally(() => {
                    this.$emit('loading', false);
                    this.loading = false;
                });
            }
        },
        // 选择文件改变
        handleChange(files, fileList) {
            this.fileList = fileList
        },
        // 移除文件
        handleRemove(file, fileList) {
            this.fileList = fileList
        },
        // 上传失败：el-upload 会把文件从列表里静默移除，这里给出提示
        handleError(err, file) {
            this.$message.error(`文件「${file.name}」上传失败，请重新上传`);
        },
        beforeUpload(file) {
            const fileTypeIsValid = this.checkFileType(file.name.split(".").pop());
            if (!fileTypeIsValid) {
                this.$message.error(this.getAlertStr(-2));
            }
            const fileSizeIsLt30M = this.checkFileSize(file.size);
            if (!fileSizeIsLt30M) {
                this.$message.error(this.getAlertStr(-3));
            }
            return fileTypeIsValid && fileSizeIsLt30M;
        },
        // 下载文件
        doDownload(file) {
            let downEle = document.createElement('a');
            downEle.href = file.url;
            downEle.setAttribute('download', file.name);
            document.body.appendChild(downEle);
            downEle.click();
            downEle.remove();
        },
        getAttachmentIds() {
            let ids = [];
            for (let item of this.fileList) {
                if (item.response !== undefined) {
                    ids.push(item.response.id);
                }
            }
            return ids.join(",");
        },
    }
}
</script>

<style scoped>
.upload-demo >>> .el-upload-dragger {
    width: 100% !important;
    height: 60px !important;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* 文件列表每一项：文件名占 90%，状态图标占 10% */
.upload-demo >>> .el-upload-list__item {
    display: flex;
    align-items: center;
}

.upload-demo >>> .el-upload-list__item-name {
    flex: 0 0 90%;
    max-width: 90%;
    margin-right: 0;
    padding-right: 8px;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.upload-demo >>> .el-upload-list__item-status-label {
    position: static;
    flex: 0 0 10%;
    width: 10%;
    text-align: center;
    opacity: 1;
    transform: none;
    display: inline-block;
}

/* hover 删除按钮占用状态图标的位置，保持右侧 10% 区域 */
.upload-demo >>> .el-upload-list__item .el-icon-close {
    right: 0;
    width: 10%;
    text-align: center;
}
</style>
